module.exports = __webpack_public_path__ + "static/img/2_2_1_2.54833a31.jpg";